export default __webpack_public_path__ + "static/media/icon_menu_settings_default.52d6a42c.svg";